import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.691 10.387c-.21.597-.878.914-1.441.703a1.125 1.125 0 0 1-.703-1.442A7.95 7.95 0 0 1 6.41 6.695a7.915 7.915 0 0 1 11.145 0l.597.633V5.5c0-.598.528-1.125 1.125-1.125.633 0 1.125.527 1.125 1.125V10a1.11 1.11 0 0 1-1.125 1.125h-4.465A1.11 1.11 0 0 1 13.689 10c0-.598.492-1.125 1.124-1.125h1.758l-.597-.598a5.687 5.687 0 0 0-7.98 0c-.598.633-1.056 1.336-1.302 2.11m-2.32 3.058c.035-.035.106-.035.14-.035.071 0 .106-.035.176-.035h4.5c.598 0 1.126.527 1.126 1.125 0 .633-.528 1.125-1.126 1.125H7.396l.597.633a5.687 5.687 0 0 0 7.98 0c.598-.633 1.055-1.336 1.301-2.11.211-.597.88-.914 1.442-.703.598.211.914.844.703 1.442-.387 1.09-1.02 2.074-1.863 2.953a7.915 7.915 0 0 1-11.145 0l-.598-.633V19c0 .633-.527 1.125-1.125 1.125A1.11 1.11 0 0 1 3.563 19v-4.641c0-.07 0-.105.036-.14.035-.176.14-.352.28-.492.142-.141.317-.247.493-.282"
    }, null, -1)
  ]))]))
}
export default { render: render }